import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import PeopleIcon from "@mui/icons-material/People";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import EventIcon from '@mui/icons-material/Event';
import SettingsIcon from '@mui/icons-material/Settings';
import React from "react";

const LoginForm = React.lazy(() => import("../components/LoginForm"));
const Scans = React.lazy(() => import("../components/Scans"));
const Cars = React.lazy(() => import("../components/Cars"));
const Detections = React.lazy(() => import("../components/Detections"));
const Inspections = React.lazy(() => import("../components/Inspections"));
const Trains = React.lazy(() => import("../components/Trains"));
const Dashboard = React.lazy(() => import("../components/Dashboard"));
const Profile = React.lazy(() => import("../components/Profile"));
const AdminDashboard = React.lazy(() =>
  import("../components/admin/AdminDashboard")
);
const MemberManagement = React.lazy(() =>
  import("../components/admin/MemberManagement")
);
const RoleManagement = React.lazy(() =>
  import("../components/admin/RoleManagement")
);
const Accounts = React.lazy(() => import("../components/admin/Accounts"));
const Portals = React.lazy(() => import("../components/admin/Portals"));
const Modules = React.lazy(() =>
  import("../components/admin/Modules")
);
const InspectionManagement = React.lazy(() => 
  import("../components/admin/InspectionManagement")
);
const InspectionConfig = React.lazy(() =>
  import("../components/admin/InspectionConfig")
);
const EventManagementLayout = React.lazy(() =>
  import("../components/eventManagement/EventManagementLayout")
);
// Note: InspectionRuleManagement has been replaced by the tabbed InspectionManagement

export const regularRoutes = [
  { name: "Scans", path: "/scans", component: <Scans />, navBar: true },
  { name: "Trains", path: "/trains", component: <Trains />, navBar: true },
  { name: "Railcars", path: "/cars", component: <Cars />, navBar: true },
  {
    name: "AI Detections",
    path: "/detections",
    component: <Detections />,
    navBar: true,
  },
  {
    name: "Inspections",
    path: "/inspections",
    component: <Inspections />,
    navBar: true,
  },
  { name: "Dashboard", path: "/", component: <Dashboard />, navBar: false },
  { name: "Profile", path: "/profile", component: <Profile />, navBar: false },
  { name: "Login", path: "/login", component: <LoginForm />, navBar: false },
];

export const adminRoutes = [
  {
    name: "Admin Dashboard",
    path: "/admin",
    component: <AdminDashboard />,
    card: false,
    navBar: false,
  },
  {
    name: "Members",
    path: "/admin/user_management",
    component: <MemberManagement />,
    icon: <PeopleIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Inspection Config",
    path: "/admin/inspection-config",
    component: <InspectionConfig />,
    icon: <SettingsIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  { name: "Profile", path: "/profile", component: <Profile />, navBar: false },
];

export const serviceProviderRoutes = [
  {
    name: "Admin Dashboard",
    path: "/admin",
    component: <AdminDashboard />,
    card: false,
    navBar: false,
  },
  {
    name: "Members",
    path: "/admin/user_management",
    component: <MemberManagement />,
    icon: <PeopleIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Roles",
    path: "/admin/role_management",
    component: <RoleManagement />,
    icon: <AdminPanelSettingsIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Accounts",
    path: "/admin/accounts",
    component: <Accounts />,
    icon: <CorporateFareIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Portals",
    path: "/admin/portals",
    component: <Portals />,
    icon: <RoomPreferencesIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Cameras",
    path: "/admin/modules",
    component: <Modules />,
    icon: <AddAPhotoIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Inspection Management",
    path: "/admin/inspection-management",
    component: <InspectionManagement />,
    icon: <BuildCircleIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  {
    name: "Event Management",
    path: "/admin/event-management",
    component: <EventManagementLayout />,
    icon: <EventIcon sx={{ fontSize: 80, color: "#1976d2" }} />,
    card: true,
    navBar: true,
  },
  { name: "Profile", path: "/admin/profile", component: <Profile />, navBar: false },
];
